import {
  makeAutoObservable,
  observable,
  action,
  computed,
  runInAction,
  toJS,
  autorun,
  reaction,
  onBecomeUnobserved,
} from "mobx";
import ColumnStore from "./column";
import RowStore from "./row";
import axios from "axios";
import { debounce, throttle } from "lodash";
import { commonAxios } from "../../CommonAxios";
import { downloadFileFromURL } from "../../../../Components/utils";
import { showAlertToast } from "../../../../Components/ToastComponent/AlertMessage.js";
import { useNavigate } from "react-router-dom";
class GridStore {
  offset = 0;
  limit = 10;
  peopleSection = false;
  columns = observable.map();
  rows = observable.map();
  sortColumn = null;
  sortDirection = "asc";
  isLoading = false;
  tableId = null;
  tablePeopleId = null;
  tableCompanyId = null;
  userId = null;
  serialColumnId = "SNO";
  anchorEl = null;
  tabIndex = 0;
  imgError = false;
  // enrichmentTableIndex = 0;
  columnLimit = 150;
  hrefColumns = new Set();
  convertColumns = new Set();
  formalizeColumns = new Set();
  enrichmentVisible = "";
  totalRecode = 0;
  freshTable = true;
  rowoffset = 1000;
  loadingTableDataFlag = false;
  bufferedRows = [];
  currentPagination = 0;
  perPaginationLimit = 10000;
  companyId = "";
  childTableId = "";
  popupState = false;
  information = "";
  socket = null;
  anchorElTab = null;
  anchorE2Tab = null;
  popupRestore = false;
  selectedRadio = "";
  selectedCRM = "";
  isFetching = false;
  totaRecordPerPage = 0;
  showWarningModal = false;
  showWarningModalFindPeople = false;
  totalCountApiCall = false;
  nextTabIndex = 0;
  freshTableNew = false;
  searchCompanyInfo = false;
  searchCompanyInfoModal = false;
  searchPeopleInfoModal = false;
  clearAllInfoModal = false;
  defaultAPIcall = true;
  indexChanges = false;
  aliesColumns = {};
  offsetValue = 0;
  isEnablePustCrm = false;
  currentHeaderTab = 'company'
  constructor(rootStore) {
    this.rootStore = rootStore;
    const serialColumn = new ColumnStore("S.No", 65);
    serialColumn.setId(this.serialColumnId); // Set consistent ID
    this.columns.set(this.serialColumnId, serialColumn);
    makeAutoObservable(this, { bufferedRows: false });
    this.handleAddColumn = this.handleAddColumn.bind(this);
    this.debouncedFetchOptions = debounce(this.fetchOptionsInternal, 300);
    this.fetchTableRecords = this.fetchTableRecords.bind(this);
    // onBecomeUnobserved(this.rows, () => this.resetStore());
    // reaction(
    //   () => [this.totaRecordPerPage],
    //   () => {
    //     runInAction(async () => {
    //       if (
    //         this.visibleRows.length > 0 &&
    //         this.visibleRows.length <= 10
    //         // this.defaultAPIcall
    //       ) {
    //         // this.defaultAPIcall = false;
    //         runInAction(() => {
    //           this.isFetching = true;
    //         });
    //         this.rootStore.generateCompanyApi({
    //           triggerKey: "",
    //           helpMe: false,
    //           isLoadMore: true,
    //         });
    //       }
    //     });
    //   }
    // );
    //     reaction(
    //   () => this.visibleRows.length,
    //   (length) => {
    //     if (length > 0 && length <= 10) {
    //       runInAction(() => {
    //         this.isFetching = true;
    //       });
    //       this.rootStore.generateCompanyApi({
    //         triggerKey: "",
    //         helpMe: false,
    //         isLoadMore: true,
    //       });
    //     }
    //   }
    // );
    // reaction(
    //   () => this.freshTableNew,
    //   () => {
    //     this.totalpageRecords();
    //     this.rootStore.fieldMapperStore.getEnrichmentFieldApi(
    //       this.tabIndex === 0 ? "company" : "people"
    //     );
    //   }
    // );
    // Debounce the reaction effect to avoid multiple rapid calls
    const debouncedGenerateCompanyApi = debounce(
      ({ total, length }) => {
        if (length > 0 && length !== total && this.freshTableNew != true) {
          this.rootStore.generateCompanyApi({
            triggerKey: "",
            helpMe: false,
            isLoadMore: true,
          });
        }
      },
      300 // Adjust debounce delay as needed
    );

    reaction(
      () => ({
        total: this.totaRecordPerPage,
        length: this.rows.size,
      }),
      debouncedGenerateCompanyApi,
      {
        fireImmediately: true,
      }
    );
  }
  resetStore() {
    runInAction(() => {
      this.columns.clear();
      this.rows.clear();
      this.sortColumn = null;
      this.sortDirection = "asc";
      this.isLoading = false;
      this.tableCompanyId = null;
      this.userId = null;
      this.serialColumnId = "SNO";
      this.anchorEl = null;
      this.tabIndex = 0;
      this.columnLimit = 150;
      this.hrefColumns.clear();
      this.enrichmentVisible = "";
      this.totalRecode = 0;
      this.freshTable = true;
      this.rowoffset = 1000;
      this.loadingTableDataFlag = false;
      this.bufferedRows = [];
      this.currentPagination = 0;
      this.perPaginationLimit = 10000;
    });
  }
  fetchOptionsInternal = async () => {
    this.fetchTableRecords(this.rows.size);
  };
  handleClick = (event) => {
    this.anchorEl = event.currentTarget;
  };
  // assignColumnLimit = (limit) => {
  //   this.columnLimit = limit;
  // };
  assignColumnHrefList = (data) => {
    if (data.hrefList && Array.isArray(data.hrefList)) {
      data.hrefList.forEach((href) => {
        this.hrefColumns.add(href);
      });
    }
  };
  handleClose = () => {
    this.anchorEl = null;
  };
  handleTabChange = (event, newValue) => {
    this.tabIndex = newValue;
  };
  // handleTabChangeEnrichment = (event, newValue) => {
  //   this.enrichmentTableIndex = newValue;
  // };
  setEnrichementVisible(value) {
    this.enrichmentVisible = value;
  }
  // Column logic
  setActiveColumn(columnId) {
    this.activeColumn = columnId;
  }
  setActiveColumn(columnId) {
    this.activeColumn = columnId;
  }
  get visibleColumns() {
    let columns = Array.from(this.columns.values())
      .filter((column) => column.visible)
      .sort((a, b) => a.orderBy - b.orderBy);
    // if (this.tabIndex === 0) {
    //   columns = columns.filter((_, index) => index !== 2);
    // }
    // if (this.tabIndex === 1) {
    //   columns = columns.filter((_, index) => index !== 6);
    // }
    // if (this.tabIndex === 1) {
    //   columns = columns.filter((_, index) => index !== 2);
    // }
    return columns;
  }
  get filteredRowCounts() {
    const columnsWithFilters = Array.from(this.columns.values()).filter(
      (col) => col.filteredRowIds.size > 0
    );
    return {
      length: columnsWithFilters.length,
      found: columnsWithFilters.length ? true : false,
    };
  }
  get filteredRowIds() {
    const columnsWithFilters = Array.from(this.columns.values()).filter(
      (col) => col.filteredRowIds.size > 0
    );
    if (columnsWithFilters.length === 0) {
      return { commonRowIds: new Set(), count: 0 };
    }
    let commonRowIds = new Set(columnsWithFilters[0].filteredRowIds);
    for (let i = 1; i < columnsWithFilters.length; i++) {
      const currentSet = columnsWithFilters[i].filteredRowIds;
      const newCommonRowIds = new Set();
      for (const id of commonRowIds) {
        if (currentSet.has(id)) {
          newCommonRowIds.add(id);
        }
      }
      commonRowIds = newCommonRowIds;
      if (commonRowIds.size === 0) {
        break;
      }
    }
    return { commonRowIds: commonRowIds, count: columnsWithFilters.length };
  }
  get visibleRows() {
    const rows = Array.from(this.rows.values());
    const filteredRowIds = this.filteredRowIds.commonRowIds; // This is now a Set
    const { found } = this.filteredRowCounts;
    if (filteredRowIds.size === 0 && found === false) {
      return rows.sort((a, b) => a.orderBy - b.orderBy);
    }
    if (filteredRowIds.size === 0 && found === true) {
      return [];
    }
    return rows
      .filter((row) => filteredRowIds.has(row.id))
      .sort((a, b) => a.orderBy - b.orderBy);
  }
  handleAddColumn = async () => {
    this.rootStore.commonAxios(
      "/addColumn",
      "POST",
      {},
      {
        tableId: this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
        userId: this.userId,
      }
    );
  };
  addColumn(obj) {
    if (!this.columns.has(this.serialColumnId)) {
      const serialColumn = new ColumnStore("S.No", 65);
      serialColumn.setId(this.serialColumnId);
      serialColumn.setOrderBy(0); // Serial column should always be first
      this.columns.set(this.serialColumnId, serialColumn);
    }
    const column = new ColumnStore(obj.customName);
    column.setId(obj.columnName);
    column.setOrderBy(obj.orderBy); // Set order on the column instance
    column.setRootStore(this.rootStore);
    this.columns.set(column.id, column);
    this.rows.forEach((row) => {
      row.addCell(column.id);
    });
  }
  renameColumn = (obj) => {
    const { columnName, data } = obj; // Destructure the obj here
    const { customName } = data || {}; // Destructure data inside obj
    const column = this.columns.get(columnName);
    if (column !== undefined) {
      column.title = customName;
    }
  };
  deleteColumn(columnId) {
    if (!this.columns.has(columnId)) return;
    if (columnId === "SNO") {
      return;
    }
    this.columns.delete(columnId);
    this.rows.forEach((row) => {
      row.deleteCell(columnId);
    });
  }
  hidecolumn(columnIds) {
    const ids = Array.isArray(columnIds) ? columnIds : [columnIds];
    ids.forEach((columnId) => {
      if (!this.columns.has(columnId)) return;
      if (columnId === "SNO") return;
      const column = this.columns.get(columnId);
      column.visible = false;
    });
  }
  refreshTableSocketCall() {
    runInAction(() => {
      this.hrefColumns.clear();
      this.fetchTableColumns(
        this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
        ""
      );
    });
  }
  async fetchTableColumns(tableId) {
    if (tableId === "default") {
      return;
    }
    this.isLoading = true;
    runInAction(() => {
      this.tableId =
        this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId;
    });
    try {
      // this.rootStore.applyTheValue({
      //   tableLoader: true,
      // });
      const response = await this.rootStore.commonAxios(
        "/getTableColumns",
        "GET",
        {
          tableId:
            this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
        },
        {}
      );
      const data = response.data || {};
      const fetchedColumns = data.columns || [];
      runInAction(() => {
        this.totaRecordPerPage = 10;
        if (data?.freshTable === true) {
          this.totalRecode = data?.totalMatching;
          this.totaRecordPerPage = 0;
        }
        // if (this.indexChanges === false) {
        //   this.totalRecode = 0;
        // }
        this.aliesColumns = data?.aliasFields;
        this.rootStore.applyTheValue({
          tableLoader: false,
        });
        this.freshTableNew = data.freshTable;
        this.columns.clear();
        this.rows.clear();
        const serialColumn = new ColumnStore("S.No", 65);
        serialColumn.setId("SNO");
        serialColumn.setOrderBy(0);
        this.columns.set("SNO", serialColumn);
        fetchedColumns.forEach((col) => {
          const column = new ColumnStore(col.customName);
          column.setId(col.columnName);
          column.setOrderBy(col.orderBy);
          column.setRootStore(this.rootStore);
          // if (col?.href) {
          //   this.hrefColumns.add(col.columnName);
          //   // column.visible = false;
          // }
          if (col?.convertNumber) {
            this.convertColumns.add(col.columnName);
            // column.visible = false;
          }
          if (col?.normalization) {
            this.formalizeColumns.add(col.columnName);
            // column.visible = false;
          }
          this.columns.set(col.columnName, column);
        });
        this.setEnrichementVisible(data.allowEnrich);
        // this.totalRecode = data.totalCount;
        // this.columnLimit = parseInt(data.columnLimit);
        this.rootStore.setTableTitle(data.tableName);
        if (data.allowCellEdit === false) {
          this.rootStore.setEditablecell(data.allowCellEdit);
        }
      });
      if (
        data.freshTable === false &&
        // this.indexChanges === true &&
        this.tabIndex !== 2
      ) {
        runInAction(() => {
          this.rootStore.generateCompanyApi({
            triggerKey: false,
            helpMe: false,
          });
          this.indexChanges === false;
        });
      }
      const payloadArray = Array.from(
        this.rootStore.getAllSelectedValues().values()
      );
      if (
        data.freshTable === true &&
        this.indexChanges === true &&
        this.rootStore.hasValidPayload(payloadArray) &&
        this.tabIndex !== 2
      ) {
        runInAction(() => {
          this.popupRestore = true;
        });
        await this.fetchTableRecords(0);
      } else if (data.freshTable === true && this.tabIndex !== 2) {
        await this.fetchTableRecords(0);
      }
      this.hidecolumn(data?.hiddenColumns);
    } catch (error) {
      this.rootStore.callCommonLoader(false);
    } finally {
      this.isLoading = false;
      if (
        this.rootStore.commonRootStoreMap.get("selectedSearchId") &&
        this.rootStore.commonRootStoreMap.get("selectedSearchId").length > 0 &&
        this.rootStore.getApiFlag
      ) {
        runInAction(() => {
          this.savedGenerate();
        });
      }
    }
  }
  async savedGenerate() {
    await this.rootStore.getSavedSearchData();
    runInAction(() => {
      this.offset = 0;
      this.totaRecordPerPage = 10;
    });
    await this.rootStore.generateCompanyApi({
      triggerKey: false,
      helpMe: false,
      ...(this.tabIndex === 0 && { spacialFlag: true }),
      ...(this.tabIndex === 1 && { spacialFlagforPeople: true }),
    });
  }
  async fetchTableRecords(offset = 0) {
    let downloadRecordsLength = 0;
    let paginatonoffset = offset;
    if (this.currentPagination > 0) {
      paginatonoffset += this.currentPagination * this.perPaginationLimit;
    }
    try {
      if (this.loadingTableDataFlag) {
        return true;
      }
      runInAction(() => {
        this.loadingTableDataFlag = true;
      });
      let tableId =
        this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId;
      if (!tableId) {
        return;
      }
      let userId = this.userId;
      const columnNames = Array.from(this.columns.keys())
        .map((col) => col)
        .join(",");
      const response = await this.rootStore.commonAxios(
        "/getTableRecords",
        "POST",
        {},
        {
          tableId:
            this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
          userId,
          offset: paginatonoffset,
          limit: 2000,
          columns: columnNames,
          type: this.tabIndex === 0 ? "company" : "people",
        }
      );
      const records = response?.data?.list || [];
      this.totaRecordPerPage = response?.data?.list?.length || 0;
      runInAction(() => {
        const columnsArray = Array.from(this.columns.keys());
        records.forEach((record, index) => {
          const row = new RowStore(columnsArray, record.id);
          row.setCell(columnsArray[0], (offset + index + 1).toString());
          columnsArray.slice(1).forEach((col) => {
            let value = record?.[col];
            row.setCellObj(col, value);
          });
          row.setOrderBy(records.orderBy);
          this.rows.set(row.id, row);
        });
      });
      downloadRecordsLength = records.length;
    } catch (error) {
    } finally {
      runInAction(() => {
        this.loadingTableDataFlag = false;
      });
      //
      // if (downloadRecordsLength && this.rows.size < this.perPaginationLimit && false) {
      //   // await this.fetchTableRecords(offset + downloadRecordsLength);
      // } else {
      // if (
      //   this.rootStore.commonRootStoreMap.get("selectedSearchId") &&
      //   this.rootStore.commonRootStoreMap.get("selectedSearchId").length >
      //   0 &&
      //   this.rootStore.getApiFlag
      // ) {
      //   runInAction(() => {
      //     this.savedGenerate();
      //   });
      // }
    }
  }
  addRow(data) {
    runInAction(() => {
      const rowId = data?.recordId;
      const columnIds = Array.from(this.columns.keys()); // Get array of column IDs
      const row = new RowStore(columnIds, rowId);
      const values = data?.values || {};
      Object.entries(values).forEach(([columnId, cellData]) => {
        if (this.columns.has(columnId)) {
          // Only set if column exists
          row.setCell(columnId, cellData.value);
        }
      });
      this.rows.set(row.id, row);
      this.updateSerialNumbers();
    });
  }
  // addRows(batch) {
  //   if (!Array.isArray(batch)) {
  //     return;
  //   }
  //   runInAction(() => {
  //     batch.forEach(({ rowId, data }) => {
  //       if (this.rows.has(rowId)) {
  //         // Merge into existing row
  //         const existingRow = this.rows.get(rowId);
  //         Object.entries(data).forEach(([columnId, cellData]) => {
  //           if (this.columns.has(columnId)) {
  //             existingRow.setCell(columnId, cellData.value);
  //           }
  //         });
  //       } else {
  //         // New row
  //         this.addRow({ recordId: rowId, values: data });
  //       }
  //     });
  //     // Reindex once
  //     this.updateSerialNumbers();
  //   });
  // }
  // Throttled function to flush batched rows into MobX state
  // Chunked update to rows (1000 at a time)
  handleIconClick = async (rowId) => {
    try {
      // Make the API call to fetch the child table ID
      this.rootStore.callCommonLoader(true);
      const response = await this.rootStore.commonAxios(
        "/getChildId",
        "GET",
        {
          userId: this.userId,
          tableId:
            this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
          rowId: rowId,
        },
        {}
      );
      const data = response.data || {};
      runInAction(() => {
        this.companyId = data.companyId;
        this.childTableId = data.childTableId;
        this.rootStore.callCommonLoader(false);
      });
    } catch (error) {
      this.rootStore.callCommonLoader(true);
    }
  };
  exportData = async (navigate) => {
    try {
      const res = await commonAxios(
        "/enrich/export",
        "POST",
        {},
        {
          userId: "4139007e-5091-7019-1a06-036626bc42ce",
          tableId:
            this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
          type: this.tabIndex === 0 ? "company" : "people",
          count: this.rootStore.getNoOfContacts,
          crmStatus: this.isEnablePustCrm ? true : false,
        }
      );
      if (res) {
        showAlertToast({
          type: "success",
          title: "Success",
          message: res.message,
        });
        runInAction(() => {
          this.anchorE2Tab = null;
          this.isEnablePustCrm = false;
        });
        setTimeout(() => {
          if (navigate) {
            navigate("/saved-table");
          }
        }, 2000);
      }
      // downloadFileFromURL(res?.data?.url);
      return false;
    } catch (error) {
      showAlertToast({
        type: "error",
        title: "Error",
        message: error?.response?.data?.error?.message,
      });
    }
  };
  exportCRM = async () => {
    try {
      const res = await commonAxios(
        "/hubspot/export",
        "POST",
        {},
        {
          tableId:
            this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
          type: this.tabIndex === 0 ? "company" : "people",
          crm: "hubspot",
        }
      );
      if (res) {
        showAlertToast({
          type: "success",
          title: "Success",
          message: "Your data is export to CRM successfully",
        });
        this.rootStore.ExportStore.setShowModal(false);
      }
      return false;
    } catch (error) { }
  };
  checkConnection = async () => {
    try {
      this.rootStore.callCommonLoader(true);
      const response = await commonAxios(
        "/crm/list",
        "GET",
        {},
        {
          // crm: "hubspot",
        }
      );
      if (response.statusCode === 200) {
        const crmList = response.data.data.crm;

        const hasDefault = crmList.some(item => item.default === true);

        if (hasDefault) {
          runInAction(() => {
            this.isEnablePustCrm = true;
          });
        } else {
          runInAction(() => {
            this.isEnablePustCrm = false;
          });
        }
      }


    } catch (error) {
      showAlertToast({
        type: "warning",
        title: `Not connected with hubspot `,
        message: `You're not currently connected to hubspot. Please establish a connection to proceed.`,
      });
    } finally {
      this.rootStore.callCommonLoader(false);
    }
  };
  totalpageRecords = async () => {
    if (this.totalCountApiCall) {
      return;
    }
    runInAction(() => {
      this.totalCountApiCall = true;
    });
    try {
      if (!(this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId))
        return;
      try {
        const response = await this.rootStore.commonAxios(
          "/getRecordsCount",
          "GET",
          {
            tableId:
              this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
          },
          {}
        );
        const data = response.data || {};
        if (response) {
          runInAction(() => {
            this.totaRecordPerPage = response.data.totalCounts;
          });
          // if (response.data.totalCounts < 11) {
          //   this.isFetching = false;
          // } else {
          //     console.log(this.rows.size < 12 && this.defaultAPIcall, "totalCounts");

          //     if (this.rows.size < 12 && this.defaultAPIcall) {
          //         runInAction(() => {
          //         this.isFetching = true;
          //       });

          //       rootStore.generateCompanyApi({
          //         triggerKey: "",
          //         helpMe: false,
          //         isLoadMore: true,
          //       });
          //     }
          //   // }
        }
        if (response?.data?.totalCounts < 11) {
          runInAction(() => {
            this.rootStore.fieldMapperStore.rowLimitRanges.toRange =
              response?.data?.totalCounts;
          });
        }
      } catch (error) { }
    } catch (error) {
    } finally {
      runInAction(() => {
        this.totalCountApiCall = false;
      });
    }
  };
  processBufferedRowsInChunks = () => {
    const chunkSize = 1000;
    const processNext = () => {
      const chunk = this.bufferedRows.splice(0, chunkSize);
      if (chunk.length === 0) {
        runInAction(() => {
          this.updateSerialNumbers();
        });
        return;
      }
      runInAction(() => {
        chunk.forEach(({ rowId, data }) => {
          if (this.rows.has(rowId)) {
            const existingRow = this.rows.get(rowId);
            Object.entries(data).forEach(([columnId, cellData]) => {
              if (this.columns.has(columnId)) {
                existingRow.setCell(columnId, cellData.value);
              }
            });
          } else {
            this.addRow({ recordId: rowId, values: data });
          }
        });
      });
      setTimeout(processNext, 0); // Schedule next chunk without blocking
    };
    processNext();
  };
  debouncedProcessBufferedRows = debounce(() => {
    this.processBufferedRowsInChunks(); // Uses chunked processing
  }, 500);
  addRows(batch) {
    if (!Array.isArray(batch)) return;
    this.bufferedRows.push(...batch);
    this.debouncedProcessBufferedRows(); // Will trigger every 100ms max
  }
  deleteRow(rowId) {
    if (this.rows.has(rowId)) {
      this.rows.delete(rowId);
      this.updateSerialNumbers();
    }
  }
  updateSerialNumbers() {
    const rowsArray = Array.from(this.rows.values());
    rowsArray.forEach((row, index) => {
      row.setCell(this.serialColumnId, (index + 1).toString());
    });
  }
  setCellInRow(rowId, columnId, value) {
    const row = this.rows.get(rowId); // Get the row by its ID
    if (row) {
      row.setCell(columnId, value); // Call setCell on the RowStore instance
    }
  }
  setSortDirectionAndSort(columnId, direction) {
    this.sortDirection = direction;
    this.sortRows(columnId.id);
  }
  sortRows(columnId) {
    const column = this.columns.get(columnId);
    if (!column) return;
    // Toggle logic fix
    if (this.sortColumn === columnId) {
      this.sortDirection = this.sortDirection === "desc" ? "desc" : "asc";
    } else {
      this.sortColumn = columnId;
      this.sortDirection = "asc";
    }
    if (column.id === this.serialColumnId) {
      this.updateSerialNumbers();
      return;
    }
    const sortedRows = Array.from(this.rows.values()).sort((rowA, rowB) => {
      const valueA = rowA.getCellValue(columnId) || "";
      const valueB = rowB.getCellValue(columnId) || "";
      // Handle empty values
      if (valueA === "" && valueB === "") return 0;
      if (valueA === "") return 1;
      if (valueB === "") return -1;
      // Try to convert to numbers for numeric comparison
      const numA = Number(valueA);
      const numB = Number(valueB);
      if (!isNaN(numA) && !isNaN(numB)) {
        // Both are valid numbers - numeric comparison
        return this.sortDirection === "asc" ? numA - numB : numB - numA;
      } else {
        // At least one is not a number - string comparison
        const compareResult = valueA.localeCompare(valueB, undefined, {
          numeric: true, // Enable natural sorting
          sensitivity: "base", // Case-insensitive
        });
        return this.sortDirection === "asc" ? compareResult : -compareResult;
      }
    });
    runInAction(() => {
      this.rows.clear();
      sortedRows.forEach((row, index) => {
        row.setOrderBy(index);
        this.rows.set(row.id, row);
      });
    });
  }
  importData(csvString) {
    try {
      const lines = csvString.split("\n");
      const headers = lines[0].split(",");
      this.columns.clear();
      this.rows.clear();
      const serialColumn = new ColumnStore("S.No", 65);
      this.columns.set(serialColumn.id, serialColumn);
      for (const element of headers) {
        if (element.trim() && element.trim() !== "S.No") {
          const column = new ColumnStore(element.trim());
          this.columns.set(column.id, column);
        }
      }
      for (let i = 1; i < lines.length; i++) {
        if (!lines[i].trim()) continue;
        const row = new RowStore(this.columns);
        const values = lines[i].split(",");
        row.setCell(serialColumn.id, i.toString());
        for (let j = 0; j < values.length && j < headers.length; j++) {
          const columnTitle = headers[j].trim();
          const column = Array.from(this.columns.values()).find(
            (col) => col.title === columnTitle
          );
          if (column && column.title !== "S.No") {
            row.setCell(column.id, values[j].trim());
          }
        }
        this.rows.set(row.id, row);
      }
      this.updateSerialNumbers();
      return true;
    } catch (error) {
      return false;
    }
  }
  // exportData() {
  //   try {
  //     const visibleColumns = this.visibleColumns;
  //     let csv = visibleColumns.map((col) => col.title).join(",") + "\n";
  //     Array.from(this.rows.values()).forEach((row) => {
  //       const rowValues = visibleColumns.map((column) => {
  //         const cellValue = row.getCellValue(column.id);
  //         return cellValue.includes(",") ? `"${cellValue}"` : cellValue;
  //       });
  //       csv += rowValues.join(",") + "\n";
  //     });
  async resetTable(navigate) {
    const res = await commonAxios(
      "/refreshTable",
      "POST",
      {},
      {
        userId: this.userId,
        tableId: this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
      }
    );
    const newTableId = res?.data?.tableId;
    if (newTableId) {
      runInAction(() => {
        this.rootStore.tableReset = true;
      });
      navigate(`/prospect-search?tableId=${newTableId}&filter=true`);
    }
  }
  reorderColumns(type, from, to) {
    runInAction(() => {
      if (type === "socket") {
        const columnOrders = Array.isArray(from) ? from : [from]; // Ensure it's an array
        const columnMap = new Map();
        const visibleColumns = this.visibleColumns.filter(
          (col) => col.id !== this.serialColumnId
        );
        visibleColumns.forEach((col) => {
          columnMap.set(col.id, col);
        });
        runInAction(() => {
          columnOrders.forEach(({ columnName, orderBy }) => {
            const column = columnMap.get(columnName);
            if (column) {
              column.setOrderBy(orderBy);
            }
          });
        });
        return;
      }
      const visibleColumns = this.visibleColumns;
      if (from === 0 || to === 0) return;
      const [movedColumn] = visibleColumns.splice(from, 1);
      visibleColumns.splice(to, 0, movedColumn);
      visibleColumns.forEach((col, index) => {
        col.setOrderBy(index);
      });
      commonAxios(
        "/changeColumnOrder",
        "POST",
        {},
        {
          tableId:
            this.tabIndex === 0 ? this.tableCompanyId : this.tablePeopleId,
          userId: this.userId,
          orderBy: { [movedColumn.id]: movedColumn.orderBy },
        }
      );
    });
  }
  clearAllColumnFilters() {
    runInAction(() => {
      this.columns.forEach((column) => {
        column.clearFilters();
      });
      this.sortColumn = null;
      this.sortDirection = "default";
    });
  }
  get hiddenColumnCount() {
    const ids = Array.from(this.columns.values())
      .filter((column) => !column.visible)
      .sort((a, b) => a.orderBy - b.orderBy);
    return { hiddenColumns: ids, count: ids.length };
  }
  resetAllHiddenColumns() {
    runInAction(() => {
      const { hiddenColumns } = this.hiddenColumnCount;
      hiddenColumns.forEach((column) => {
        column.visible = true;
      });
    });
  }
  get getRowsLength() {
    return Array.from(this.rows.values()).length;
  }
  get columnFillterEnable() {
    return true;
  }
  get disableButton() {
    let result = {
      previous: 1,
      next: 1,
    };
    const totalPages = Math.ceil(this.totalRecode / this.perPaginationLimit);
    if (this.currentPagination === 0) {
      result.previous = 0;
    }
    if (this.currentPagination >= totalPages - 1) {
      result.next = 0;
    }
    return result;
  }
  loadRecordss(process) {
    runInAction(() => {
      this.rows.clear();
      this.currentPagination =
        parseInt(this.currentPagination) + parseInt(process);
      this.fetchTableRecords(0);
    });
  }
  get totalRecordsHtml() {
    const total = this.totalRecode || 0;
    let current = this.rows.size;
    current += this.currentPagination * this.perPaginationLimit;
    if (total === current) {
      return `${total}`;
    } else {
      return `${current} / ${total}`;
    }
  }
  getCellObjsForRow(rowId, tabIndex) {
    const row = this.rows.get(rowId);
    const emailColumnId = this.aliesColumns?.email;
    const phoneColumnId = this.aliesColumns?.phone;
    const { cells } = row;
    const emailCellObj = cells.get(emailColumnId);
    const phoneCellObj = cells.get(phoneColumnId);
    return { emailCellObj, phoneCellObj };
  }
  setaliesColumns(aliesColumns) {
    this.aliesColumns = aliesColumns;
  }

  setCurrentHeaderTab = (value) => {
    runInAction(() => {
      this.currentHeaderTab = value;
    });
  };
  get getCurrentheaderTab() {
    return this.currentHeaderTab;
  }
  handleCurrentHeaderTabChange(event, newValue) {
    console.log(newValue, "Got in change for newValue");
    this.setCurrentHeaderTab(newValue);
    if (newValue === "company" || newValue === 'people') {
      runInAction(() => {
        this.offset = 0;
        this.tabIndex = newValue === 'company' ? 0 : 1;
        this.indexChanges = true;
        this.rootStore.resetAllActivefun();
      });
    }
  };

  getValidHeader() {
    const state = this?.getCurrentheaderTab;
    return state === "company" || state === "people";
  }

}
export default GridStore;
